function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
if (window.location.href.indexOf('?mode=dev') > 0) {
    setCookie('mode', 'dev', 1);
}
if (window.location.href.indexOf('?mode=live') > 0) {
    setCookie('mode', 'live', 1);
}
window.mode = 'live';
var cmode = getCookie('mode');
if (cmode.length > 0) {
    window.mode = cmode;
}
console.log(window.mode)